<div class="filter-popover">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="filter-content">
      <formly-form [form]="formGroup" [fields]="fields" [model]="model"></formly-form>
    </div>
    <div class="filter-actions">
      <button type="button" class="btn-reset" (click)="onReset()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
          <path d="M3 3v5h5"></path>
        </svg>
        Reset
      </button>
      <button type="submit" class="btn-apply">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        Apply
      </button>
    </div>
  </form>
</div>